/**
 * Created by Mark on 19/04/2017.
 */



import React from "react";
import FormGroup from 'react-bootstrap/lib/FormGroup';
import $ from 'jquery';

export default class FloatLabelGroup extends React.Component {

    constructor(props){
        super( );
        this.props = props;
        this.state ={
            validation:props.validationState
        }
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({ validation:this.props.validationState });
    }


    render(){

        return <FormGroup className="fg-float" validationState={this.state.validation || null }>
                    <div className={(this.state.validation ? "fg-toggled " : "") + "fg-line fg-float"}>
                        {this.props.children}
                    </div>
                    <small>{this.props.helpBlock}</small>
                </FormGroup>
      /*  return <FormGroup validationState={this.state.validation}>

            <FormGroup/>;*/
    }
}


// WEBPACK FOOTER //
// ./src/components/inputs/fg-input.js